import React from 'react';
import clsx from 'clsx';

import {
    IconButton,
    Snackbar,
    SnackbarContent,
    makeStyles
} from '@material-ui/core'

import {
    Close as CloseIcon,
    CheckCircle as CheckCircleIcon,
    Error as ErrorIcon,
    Info as InfoIcon,
    Warning as WarningIcon
} from '@material-ui/icons'

import SnackbarContext from './SnackbarContext';

const useStyles = makeStyles(theme => ({
    success: {
        backgroundColor: theme.palette.success.main
    },
    warning: {
        backgroundColor: theme.palette.warning.main
    },
    error: {
        backgroundColor: theme.palette.error.main
    },
    info: {
        backgroundColor: theme.palette.info.main
    },
    icon: {
        fontSize: 20
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1)
    },
    message: {
        display: 'flex',
        alignItems: 'center'
    }
}));

function MySnackbarContentWrapper(
    {
        className,
        message,
        onClose,
        variant
    }
) {
    const classes = useStyles();
    const variantIcon = {
        success: CheckCircleIcon,
        warning: WarningIcon,
        error: ErrorIcon,
        info: InfoIcon,
    };
    const Icon = variantIcon[variant];

    return (
        <SnackbarContent
            className={clsx(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message}>
                    <Icon className={clsx(classes.icon, classes.iconVariant)} />
                    {message}
                </span>
            }
            action={[
                <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
                    <CloseIcon className={classes.icon} />
                </IconButton>
            ]}
        />
    );
}

function SnackbarMensagem(
    {
        config,
        handleClose
    }
) {
    return (
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            open={config.open}
            autoHideDuration={3000}
            onClose={handleClose}>
            <MySnackbarContentWrapper onClose={handleClose}
                variant={config.variant}
                message={config.message} />
        </Snackbar>
    );
}

function SnackbarProvider(
    {
        children
    }
) {
    const initialState = {
        open: false,
        message: null,
        variant: null
    };

    const [config, setConfig] = React.useState(initialState);

    const handleShow = (variant, message) => {
        setConfig({
            open: true,
            variant,
            message
        });
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway')
            return;

        setConfig(initialState);
    };

    return (
        <>
            <SnackbarContext.Provider value={{ show: handleShow }}>
                {children}
            </SnackbarContext.Provider>
            {
                config.open &&
                <SnackbarMensagem config={config}
                    handleClose={handleClose} />
            }
        </>
    );
}

export default SnackbarProvider;